"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Typeahead = _interopRequireDefault(require("../../Form/Typeahead/Typeahead"));
var _constants = require("../../utils/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RegionSelect = ({
  onSearch,
  lng,
  country,
  geonameId,
  regionLevel,
  allowCustomValue,
  size,
  maxItems,
  showAsCombobox,
  ...args
}) => {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [options, setOptions] = (0, _react.useState)([]);
  const [hasLoaded, setHasLoaded] = (0, _react.useState)(false);
  const formattedRegions = function (regions) {
    return regions.map(region => {
      return {
        name: region.name,
        geonameId: region.geonameId
      };
    });
  };
  (0, _react.useEffect)(() => {
    const fetchData = async () => {
      if (hasLoaded || !country || !lng) {
        return;
      }
      try {
        var _json$data;
        setIsLoading(true);
        const response = await fetch(`${_constants.SEARCH_URI}?country=${country}&lng=${lng}`);
        const json = await response.json();
        const regions = formattedRegions((_json$data = json.data) == null ? void 0 : _json$data.regions);
        setOptions(regions);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [country, lng]);
  (0, _react.useEffect)(() => {
    setHasLoaded(true);
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typeahead.default, {
    ...args,
    isLoading: allowCustomValue ? false : isLoading,
    labelKey: "name",
    minLength: 1,
    onChange: onSearch,
    size: size,
    maxItems: maxItems,
    showAsCombobox: showAsCombobox,
    open: allowCustomValue ? false : undefined,
    options: allowCustomValue ? [] : options
  });
};
var _default = exports.default = RegionSelect;
module.exports = exports.default;